import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { faBars } from '@fortawesome/pro-light-svg-icons'
import { faBars as faBarsSolid } from '@fortawesome/pro-solid-svg-icons'
import { TooltipModule } from 'primeng/tooltip'
import { ButtonModule } from 'primeng/button'
import { MobileMenuComponent } from '../mobile-menu/mobile-menu.component'
import { UserService } from '@app/core/_services/user.service'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { DrawerModule } from 'primeng/drawer'
import { MenuDrawerStateService } from '@app/navigation/services/menu-drawer-state.service'
import { ViewportService } from '@app/core/_services/viewport.service'

@Component({
    selector: 'fm-menu-link',
    imports: [
        MobileMenuComponent,
        RouterModule,
        CommonModule,
        TooltipModule,
        ButtonModule,
        FontAwesomeModule,
        DrawerModule,
    ],
    templateUrl: './menu-link.component.html',
    styleUrl: './menu-link.component.scss',
})
export class MenuLinkComponent {
    public faBars = faBars
    public faBarsSolid = faBarsSolid
    public isHovered = false

    constructor(
        public menuDrawerStateService: MenuDrawerStateService,
        public userService: UserService,
        public viewportService: ViewportService,
    ) {}

    ngOnInit(): void {}

    onMenuItemClicked() {
        this.menuDrawerStateService.close()
    }

    onClickToggleMenu(): void {
        this.menuDrawerStateService.toggle()
    }

    onMouseEnter() {
        if (!('ontouchstart' in window)) {
            this.isHovered = true
        }
    }

    onMouseLeave() {
        if (!('ontouchstart' in window)) {
            this.isHovered = false
        }
    }

    ngOnDestroy() {}
}
